import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	relationshipsSectionBaseTitle: {
		id: 'fastshift.relationships-section.title',
		defaultMessage: 'Help with migration',
		description: 'Title for the relationships section',
	},
});
